var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCorporateFareLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8761_19681)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3601 36.6173H14.6001C12.6101 36.6173 11.0001 35.0073 11.0001 33.0173V14.2173C11.0001 12.2273 12.6101 10.6173 14.6001 10.6173H25.4001C27.3901 10.6173 29.0001 12.2273 29.0001 14.2173V23.1173",
    stroke: "#121619",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5001 17.1173H23.5001",
    stroke: "#121619",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5001 23.6173H23.5001",
    stroke: "#121619",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2704 38.1173H28.2504C27.1804 38.1173 26.3204 37.2573 26.3204 36.1873V25.0473C26.3204 23.9773 27.1804 23.1173 28.2504 23.1173H33.9204L38.2104 27.4073V36.1973C38.2104 37.2673 37.3504 38.1273 36.2804 38.1273L36.2704 38.1173Z",
    stroke: "#121619",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2003 27.4073H35.1103C34.4503 27.4073 33.9103 26.8673 33.9103 26.2073V23.1173L38.2003 27.4073Z",
    fill: "#121619",
    stroke: "#121619",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9005 31.5577H34.5605",
    stroke: "#121619",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.45 29.5371H21.56C22.22 29.5371 22.76 30.0771 22.76 30.7371V36.6271H17.25V30.7371C17.25 30.0771 17.79 29.5371 18.45 29.5371Z",
    stroke: "#121619",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8761_19681"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCorporateFareLight);
export default __webpack_public_path__ + "static/media/icon_corporate_fare_light.f0297340.svg";
export { ForwardRef as ReactComponent };